export const SET_FILE_STORAGE = 'SET_FILE_STORAGE';
export const SET_FILES = 'SET_FILES';
export const CLEAR_FILE_STORAGE = 'CLEAR_FILE_STORAGE';